export default window.__RUNTIME_CONFIG__.REACT_APP_GA_ID || 'UA-83192564-2';